// extracted by mini-css-extract-plugin
export const main = "clarification-text-module--main--zR53A";